<script lang="ts">
  import { getBillingType } from '../../helpers/sections-helper';
  import { moneyFormat } from '../../helpers/price-helper';
  import type { GlobalProperties } from 'customer-components/lib/types';

  export let card;
  export let priceType = 'Hourly';
  export let billingType = 'Weekly';
  export let background: GlobalProperties['background'];
</script>

<div class="pricing-card" style="border-color:{background};">
  <div class="text">
    <h3>{card?.title || ''}</h3>
    <p>{@html card?.description || ''}</p>
  </div>

  {#if card?.discountPrice || card?.price}
    <div class="prices {priceType}">
      {#if priceType === 'Hourly'}
        <div class="price-section">
          <span class="price-symbol">$</span>
          <div class="amount">
            <p class="price">{moneyFormat(card?.discountPrice)}</p>
            <span class="price-week">/{getBillingType(billingType)}</span>
          </div>
        </div>

        {#if card?.price}
          <div class="old-price">
            ${moneyFormat(card?.price)}
            <span class="old-billing">/{getBillingType(billingType)}</span>
          </div>
        {/if}
      {:else}
        <div class="price-section">
          <span class="price-symbol">$</span>
          <p class="price">{moneyFormat(card?.discountPrice)}</p>
        </div>

        {#if card?.price}
          <p class="old-price">${moneyFormat(card?.price)}</p>
        {/if}
      {/if}
    </div>
  {/if}

  <ul>
    {#if card?.benefits?.length}
      {#each card.benefits as benefit}
        {#if benefit}
          <li>{benefit}</li>
        {/if}
      {/each}
    {/if}
  </ul>
</div>

<style>
  .pricing-card {
    background: #ffffff;
    border: 1px solid #eaeaeb;
    box-shadow: 0 12px 32px rgba(10, 31, 92, 0.04);
    border-radius: 8px;
    padding: 40px 20px 30px;
    border-top: 6px solid #336fcc;
  }

  .text {
    max-width: 320px;
    word-break: break-word;
  }
  .amount {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
  }
  h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    margin: 0;

    color: #0e0f11;
  }

  p {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    margin-top: 8px;
    margin-bottom: 0;

    color: #787e87;
  }
  .price-section {
    display: flex;
    align-items: flex-end;
    margin-top: 8px;
  }
  .prices {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .prices.Hourly {
    justify-content: space-between;
    align-items: start;
  }
  .price {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    text-transform: capitalize;
    color: #0e0f11;
    margin-top: 0;
  }
  .price-week {
    display: inline-flex;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    white-space: nowrap;
    text-transform: lowercase;

    color: #0e0f11;
  }
  .old-billing {
    display: inline-flex;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    margin-left: -2px;
    white-space: nowrap;
    text-transform: lowercase;
  }
  .price-symbol {
    font-weight: 500;
    font-size: 16px;
    line-height: 32px;
    margin-right: 2px;
    color: #0e0f11;
  }

  .old-price {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    text-decoration-line: line-through;
    margin: 0 0 0 8px;
    color: #f74d4f;
  }

  ul {
    margin-top: 20px;
    padding: 0;
    word-break: break-word;
  }

  ul li {
    position: relative;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 12px;
    list-style: none;
    padding-left: 1.2rem;
  }

  ul li:before {
    position: absolute;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    content: '';
    min-width: 1.2rem;
    min-height: 1.2rem;
    left: -5px;
    top: 3px;
    background: url('https://voolt-template-asset.s3.amazonaws.com/check.svg');
    vertical-align: middle;
    margin-bottom: auto;
    background-repeat: no-repeat;
  }
</style>
